import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';

const AboutPage = () => {
  const { t } = useLang();

  const values = [
    { icon: '🏆', title: t('val_quality'),     desc: t('val_quality_desc') },
    { icon: '🚀', title: t('val_innovation'),  desc: t('val_innovation_desc') },
    { icon: '💯', title: t('val_trust'),       desc: t('val_trust_desc') },
    { icon: '🤝', title: t('val_service'),     desc: t('val_service_desc') },
  ];

  const stats = [
    { n: '10K+', label: t('about_stat_products') },
    { n: '50K+', label: t('about_stat_customers') },
    { n: '5+',   label: t('about_stat_years') },
    { n: '4.9★', label: t('about_stat_rating') },
  ];

  return (
    <div className="about-page">
      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero__inner">
          <img src="/logo-matrix.png" alt="Matrix logo" className="about-logo" />
          <h1>{t('about_title')}</h1>
          <p>{t('about_subtitle')}</p>
        </div>
        <div className="about-hero__orb about-hero__orb--1" />
        <div className="about-hero__orb about-hero__orb--2" />
      </div>

      {/* Stats */}
      <div className="about-stats">
        {stats.map(s => (
          <div key={s.label} className="about-stat">
            <strong>{s.n}</strong>
            <span>{s.label}</span>
          </div>
        ))}
      </div>

      {/* Story */}
      <div className="about-section">
        <div className="about-section__inner">
          <div className="about-text">
            <h2>{t('our_story')}</h2>
            <p>{t('our_story_p1')}</p>
            <p>{t('our_story_p2')}</p>
            <Link to="/contact" className="btn btn--primary" style={{ marginTop: 16, display: 'inline-flex' }}>
              {t('contact_us_btn')}
            </Link>
          </div>
          <div className="about-image-grid">
            <img src="https://images.unsplash.com/photo-1607853202273-797f1c22a38e?w=400&h=300&fit=crop" alt="store" />
            <img src="https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=400&h=300&fit=crop" alt="products" />
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="about-values">
        <h2 className="about-values__title">{t('our_values')}</h2>
        <div className="values-grid">
          {values.map(v => (
            <div className="value-card" key={v.title}>
              <span className="value-icon">{v.icon}</span>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="about-cta">
        <h2>{t('about_cta_title')}</h2>
        <p>{t('about_cta_sub')}</p>
        <Link to="/" className="btn btn--primary">{t('shop_now_btn')}</Link>
      </div>
    </div>
  );
};

export default AboutPage;
